function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import ModalDialog from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/modal-dialog';
import TextInput from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/text-input';
import TranslationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/translation-manager';
import { TranslationKeys } from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/const';
import Loader from 'react-loader-advanced';
import { loaderBackgroundStyle, loaderOpacity, spinner } from './views/Spinner';
import CheckUtils from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/utilities/check-utils';
var UserManagementEditModal = /*#__PURE__*/function (_React$Component) {
  function UserManagementEditModal(props) {
    var _this;
    _classCallCheck(this, UserManagementEditModal);
    _this = _callSuper(this, UserManagementEditModal, [props]);
    _this.state = {
      selectedRole: '',
      editSaveModalLoading: false,
      roles: [{
        title: 'Admin/Owner',
        id: 'ADMIN'
      }, {
        title: 'Purchaser with pricing',
        id: 'PURCHASER'
      }, {
        title: 'Purchaser without pricing',
        id: 'PURNOPRICE'
      }, {
        title: 'Associate',
        id: 'ASSOCIATE'
      }, {
        title: 'Marketing',
        id: 'MARKETING'
      }]
    };
    _this.translations = {
      editModalAddressText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_ADDRESS_TEXT),
      editModalBusinessEmailReqText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_BUSINESS_EMAIL_REQUIRED_TEXT),
      editModalExistingRoleText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_EXISTING_ROLE_TEXT),
      editModalFaxText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_FAX_TEXT),
      editModalIDText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_ID_TEXT),
      editModalNameText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_NAME_TEXT),
      editModalNewRoleDescText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_NEW_ROLE_DESC_TEXT),
      editModalNewRoleText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_NEW_ROLE_TEXT),
      editModalPersonalEmailText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_PERSONAL_EMAIL_TEXT),
      editModalBusinessEmailText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_BUSINESS_EMAIL_TEXT),
      editModalPhoneRequiredText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_PHONE_REQUIRED_TEXT),
      editModalPhoneText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_PHONE_TEXT),
      editModalEditUserText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_EDIT_USER_TEXT),
      editModalEmailValidateText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_EMAIL_VALIDATE_TEXT),
      editModalPhoneValidateText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_PHONE_VALIDATE_TEXT),
      editModalChooseRoleText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_EDIT_MODAL_CHOOSE_ROLE_TEXT)
    };
    _this.onSelectChange = _this.onSelectChange.bind(_this);
    return _this;
  }
  _inherits(UserManagementEditModal, _React$Component);
  return _createClass(UserManagementEditModal, [{
    key: "onSelectChange",
    value: function onSelectChange(event) {
      var _this2 = this;
      var currentTarget = event.target.value;
      this.setState({
        selectedRole: currentTarget
      }, function () {
        _this2.setProp();
      });
    }
  }, {
    key: "setProp",
    value: function setProp() {
      this.props.passSelectedRole(this.state.selectedRole);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var editUser = this.props.editUser;
      return /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.props.userManagementEditModalIsOpen,
        className: "wdh-feature-btb-modalContent wdh-feature-btb-modalContent-userMng-Edit-Modal",
        type: "okCancel",
        okLabel: "Save",
        onOkClick: function onOkClick() {
          return _this3.props.onSaveEditModal();
        },
        onCancelClick: function onCancelClick() {
          return _this3.props.closeModal();
        },
        cancelLabel: "Cancel",
        showCloseButton: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "user-management-edit-modal"
      }, /*#__PURE__*/React.createElement(Loader, {
        show: this.props.saveLoading,
        message: spinner,
        contentBlur: loaderOpacity,
        backgroundStyle: loaderBackgroundStyle
      }, /*#__PURE__*/React.createElement("h3", null, this.translations.editModalEditUserText), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td"
      }, this.translations.editModalNameText), /*#__PURE__*/React.createElement("td", null, editUser.name)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td"
      }, this.translations.editModalIDText), /*#__PURE__*/React.createElement("td", null, editUser.loginId)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td role-td"
      }, this.translations.editModalExistingRoleText), /*#__PURE__*/React.createElement("td", null, editUser.role)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td"
      }), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("p", {
        className: "edit-modal-new-role-text"
      }, this.translations.editModalNewRoleDescText))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td"
      }, this.translations.editModalNewRoleText), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
        className: "edit-modal-select"
      }, /*#__PURE__*/React.createElement("select", {
        onChange: this.onSelectChange
      }, /*#__PURE__*/React.createElement("option", {
        hidden: true,
        disabled: true,
        selected: true,
        value: true
      }, this.translations.editModalChooseRoleText), this.state.roles.map(function (role) {
        return /*#__PURE__*/React.createElement("option", {
          value: role.id,
          key: role.id,
          id: role.id
        }, role.title);
      }))))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td"
      }, this.translations.editModalAddressText), /*#__PURE__*/React.createElement("td", null, !CheckUtils.isNullOrEmptyObject(editUser.address) && /*#__PURE__*/React.createElement(React.Fragment, null, "".concat(editUser.address.addressLine1, ", ").concat(editUser.address.addressLine2), /*#__PURE__*/React.createElement("br", null), "".concat(editUser.address.city, ", ").concat(editUser.address.state, ", ").concat(editUser.address.postalCode)))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td input-edit-box"
      }, this.translations.editModalBusinessEmailText), /*#__PURE__*/React.createElement("td", {
        className: "second-td"
      }, /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "businessEmail",
        id: "businessEmail",
        onValueChange: function onValueChange(event) {
          _this3.props.onEditUserUpdated(event.target.value, editUser.personalEmail, editUser.phone, editUser.fax);
        },
        inputValue: editUser.businessEmail,
        autoComplete: "email work"
      })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td input-edit-box"
      }, this.translations.editModalPersonalEmailText), /*#__PURE__*/React.createElement("td", {
        className: "second-td"
      }, /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "PersonalEmail",
        id: "PersonalEmail",
        onValueChange: function onValueChange(event) {
          _this3.props.onEditUserUpdated(editUser.businessEmail, event.target.value, editUser.phone, editUser.fax);
        },
        inputValue: editUser.personalEmail,
        autoComplete: "email home"
      })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td input-edit-box"
      }, this.translations.editModalPhoneText), /*#__PURE__*/React.createElement("td", {
        className: "second-td"
      }, /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "Phone",
        onValueChange: function onValueChange(event) {
          _this3.props.onEditUserUpdated(editUser.businessEmail, editUser.personalEmail, event.target.value, editUser.fax);
        },
        inputValue: editUser.phone,
        autoComplete: "tel"
      })))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "edit-modal-td input-edit-box last-fax"
      }, this.translations.editModalFaxText), /*#__PURE__*/React.createElement("td", {
        className: "second-td"
      }, /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "Fax",
        onValueChange: function onValueChange(event) {
          _this3.props.onEditUserUpdated(editUser.businessEmail, editUser.personalEmail, editUser.phone, event.target.value);
        },
        inputValue: editUser.fax,
        autoComplete: "fax"
      })))))), this.props.businessEmailRequired && /*#__PURE__*/React.createElement("p", {
        className: "form-not-filled"
      }, this.translations.editModalBusinessEmailReqText), this.props.phoneNoRequired && /*#__PURE__*/React.createElement("p", {
        className: "form-not-filled"
      }, this.translations.editModalPhoneRequiredText), this.props.emailValidate && /*#__PURE__*/React.createElement("p", {
        className: "form-not-filled"
      }, this.translations.editModalEmailValidateText), this.props.phoneNoValid && /*#__PURE__*/React.createElement("p", {
        className: "form-not-filled"
      }, this.translations.editModalPhoneValidateText))));
    }
  }]);
}(React.Component);
UserManagementEditModal.propTypes = {
  closeModal: PropTypes.func,
  onSaveEditModal: PropTypes.func,
  businessEmailRequired: PropTypes.bool,
  phoneNoRequired: PropTypes.bool,
  phoneNoValid: PropTypes.bool,
  emailValidate: PropTypes.bool,
  onEditUserUpdated: PropTypes.func,
  userManagementEditModalIsOpen: PropTypes.bool.isRequired,
  editUser: PropTypes.objectOf(PropTypes.any),
  saveLoading: PropTypes.bool
};
UserManagementEditModal.defaultProps = {
  closeModal: function closeModal() {},
  onSaveEditModal: function onSaveEditModal() {}
};
export default UserManagementEditModal;